import { useEffect, useState } from 'react'; // Added useState for local dashboard data
import { Link,useNavigate } from 'react-router-dom';
import { Spinner, Alert  } from 'flowbite-react'; // Added Progress and Alert
import { HiHome,HiOutlineUserGroup, HiOutlineDocumentDownload } from 'react-icons/hi'; // Added icons for dashboard cards

import PageHeading from '../../../components/PageHeading';
import StatCount from './components/StatCount';
const DashboardPage = () => {
    const navigate = useNavigate();
    const [dashboardData, setDashboardData] = useState({
        totalCustomers: 0,
        recentUploads: 0
    });
    const [loadingData, setLoadingData] = useState(true); // State for dashboard data loading
    const [dataError, setDataError] = useState(null); // State for dashboard data errors

    // Effect to check authentication status and set page title on component mount
    useEffect(() => {
        document.title = 'CPA - Dashboard';

        const accessToken = localStorage.getItem('access_token');
        
        if (!accessToken) {
            navigate('/');
        }

        // Simulate fetching dashboard data
        const fetchDashboardData = async () => {
            setLoadingData(true);
            setDataError(null);
            try {
                // Simulate API delay
                await new Promise(resolve => setTimeout(resolve, 1000));
                setDashboardData({
                    totalCustomers: 1250,
                    recentUploads: 45
                });
            } catch (err) {
                console.error("Failed to fetch dashboard data:", err);
                setDataError("Failed to load dashboard data. Please try again.");
            } finally {
                setLoadingData(false);
            }
        };

        fetchDashboardData();

    }, [navigate]);

    return (
        <div className="p-4 sm:p-6 lg:p-8"> {/* Adjusted padding for better spacing */}
         

            <PageHeading value="Admin Dashboard" />
            {dataError && (
                <Alert color="failure" onDismiss={() => setDataError(null)} className="mb-6">
                    <span className="font-medium">Data Loading Error!</span> {dataError}
                </Alert>
            )}

            {loadingData ? (
                <div className="flex justify-center items-center h-64">
                    <Spinner size="xl" />
                    <p className="ml-3 text-lg text-gray-500 dark:text-gray-400">Loading Dashboard...</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {/* Card 1: Total Customers */}
                    
                    <StatCount label="Total Customers" IconComponent={HiOutlineUserGroup} count={dashboardData.totalCustomers}/>
                    

                    <StatCount label="Recent Uploads" IconComponent={HiOutlineDocumentDownload} count={dashboardData.recentUploads}/>

                   
                </div>
            )}
        </div>
    );
};

export default DashboardPage;